import React, { Component } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { Divider } from 'semantic-ui-react';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';
import { RouterProps } from 'react-router';
import { BillJournalData, BillJournalSearchResponse } from 'ts-types/api.types';
import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import StyledErrorMessage from 'components/layout/StyledErrorMessage';
import BillJournalOptionsSegment from 'components/billing/bill-journal/segments/BillJournalOptionsSegment';
import BillJournalTableSegment from 'components/billing/bill-journal/segments/BillJournalTableSegment';
import { BillJournalOrderBy } from 'ts-types/api.enums';
import moment from 'moment';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export interface BillJournalFormData {
  bills: Array<BillJournalSearchResponse>,
  mandateId: number,
  fromDate: string,
  toDate: string,
  orderBy: BillJournalOrderBy
}

interface Props extends AuthConsumerRenderProps, MessageSourceProps, RouterProps {
}

interface State {
  billJournalData: BillJournalData,
  billsLoading: boolean,
  formData: BillJournalFormData,
  errorMessage?: string,
  cancelTokenSource: CancelTokenSource
}

class BillJournalView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      billJournalData: this.initialBillJournalDataValues(),
      billsLoading: false,
      formData: this.initialOutputFormValues(),
      cancelTokenSource: cancelTokenSource
    };

  }

  initialOutputFormValues = (): BillJournalFormData => {

    const {currentUser} = this.props;

    const fromDate = moment().startOf('month').format("YYYY-MM-DD");
    const toDate = moment().endOf('month').format("YYYY-MM-DD");

    return {
      mandateId: currentUser ? currentUser.userConfig.mandateId : 1,
      fromDate: fromDate,
      toDate: toDate,
      orderBy: BillJournalOrderBy.BILL_NUMBER,
      bills: []
    }
  };

  initialBillJournalDataValues = (): BillJournalData => {
    return {
      bills: [],
      totalAmount: 0,
      totalPaidAmount: 0,
      totalOpenAmount: 0,
      totalStornoAmount: 0
    }
  };

  setOutputFormData = (outputFormData: BillJournalFormData): void => {
    this.setState({
      formData: outputFormData
    });
  }

  setErrorMessage = (errorMessage?: string) => {
    this.setState({
      errorMessage: errorMessage
    });
  };

  onFilterBillJournalData = (billJournalData: BillJournalData) => {
    this.setState({
      billJournalData: billJournalData
    })
  };

  onBillsLoadingChange = (billsLoading: boolean) => {
    this.setState({
      billsLoading: billsLoading
    })
  };

  render(): React.ReactElement {

    const {
      billJournalData,
      billsLoading,
      formData,
      errorMessage
    } = this.state;

    return (
        <PraxStyledSegment>
          <StyledContainer>
            {errorMessage
            && (
                <StyledErrorMessage onDismiss={() => this.setErrorMessage()} style={{margin: 0}}>
                  {errorMessage}
                </StyledErrorMessage>
            )
            }
            <BillJournalOptionsSegment
                bills={billJournalData.bills}
                onFilterBillJournalData={this.onFilterBillJournalData}
                onBillsLoadingChange={this.onBillsLoadingChange}
                setOutputFormData={this.setOutputFormData}
                setErrorMessage={this.setErrorMessage}
            />
            <Divider/>
            <BillJournalTableSegment
                billJournalData={billJournalData}
                billsLoading={billsLoading}
                formData={formData}
                setErrorMessage={this.setErrorMessage}
            />
          </StyledContainer>
        </PraxStyledSegment>
    );
  }

}

export default withAuthContext(withMessages(BillJournalView));
